import React from "react";
import { Link, ResponsiveImage } from "@quintype/components";
import AuthorDefaultLogo from "../../atoms/author-default-img";

import "./author-listing-card.m.css";

const AuthorListingCard = ({ author }) => {
  const name = author.name;
  const avatarURL = author["avatar-s3-key"];
  const authorAvatarUrl = author["avatar-url"];

  return (
    <Link href={`/author/${author?.slug}`} styleName="wrapper">
      <div styleName="author-image">
        {avatarURL ? (
          <ResponsiveImage
            slug={avatarURL}
            aspectRatio={[1, 1]}
            alt={name.substring(1)}
            widths={[100]}
            imgParams={{ auto: ["format", "compress"], fit: "max" }}
          />
        ) : authorAvatarUrl ? (
          <img src={authorAvatarUrl} alt={name} />
        ) : (
          <AuthorDefaultLogo width={240} height={240} />
        )}
      </div>
      <h2 styleName="author-name">{author?.name}</h2>
    </Link>
  );
};

export default AuthorListingCard;
